module.exports = __webpack_public_path__ + "img/inharmony.8c9fc364.jpg";